import { BodyLG, BodyMD, HeadingLG, HeadingXL } from "../../../typography";

import { RiveAnimation } from "../../components/ui/RiveAnimation";

export const Card = ({
  src,
  fallbackSrc,
  title,
  description,
}: {
  src: string;
  fallbackSrc: string;
  title: string;
  description: string;
}) => (
  <div className="tw-flex tw-w-[calc(100vw-48px)] tw-shrink-0 tw-snap-center tw-flex-col tw-gap-y-[16px] min440:tw-w-[calc(33.33%-16px)]">
    <RiveAnimation
      src={src}
      fallbackSrc={fallbackSrc}
      className="tw-aspect-[445/594] tw-h-fit"
      fallbackClassName="tw-aspect-[445/594] tw-h-fit"
    />
    <HeadingXL className="tw-my-0 tw-hidden min440:tw-flex">{title}</HeadingXL>
    <HeadingLG className="tw-my-0 tw-pl-[16px] min440:tw-hidden">
      {title}
    </HeadingLG>

    <BodyLG className="tw-hidden tw-pl-[16px] min440:tw-flex min440:tw-px-0">
      {description}
    </BodyLG>
    <BodyMD className="tw-my-0 tw-pl-[16px] min440:tw-hidden">
      {description}
    </BodyMD>
  </div>
);
